import React, { useState } from 'react';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import CancelButton from '../../../../../../component/ui/buttons/cancel-button/cancel-button';
import ApproveButtons from '../../../../../../component/ui/buttons/approve-button/approve-buttons';
import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { Chip } from 'primereact/chip';
import { MultiSelect } from 'primereact/multiselect';
import { Major } from '../../../../../../api/types/settings/studies/major';
import { AbstractCourse } from '../../../../../../api/types/settings/studies/abstract-course';
import { EditNumber } from '../../../../../../component/ui/edit-text/edit-number';
import { SupervisoryInstitution } from '../../../../../../api/types/settings/studies/supervisory-institution';
import { createNewAbstractCourseOperation } from './operation/create-new-abstract-course-operation';
import { AbstractProgram } from '../../../../../../api/types/settings/studies/abstract-program';
import { AbstractProgramExistingCourses } from './componenets/abstract-program-existing-courses';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { AbstractProgramFindCourses } from './componenets/abstract-program-find-courses';
import { abstractProgramAddCourses } from './operation/abstract-program-add-courses';

export const AbstractProgramAddDialog: React.FC<{
  closeDialog: () => void;
  abstractProgram?: AbstractProgram;
}> = ({ closeDialog, abstractProgram }) => {
  const [programName, setProgramName] = useState(
    abstractProgram?.programName ?? '',
  );
  const [programYears, setProgramYears] = useState(abstractProgram?.years ?? 1);

  const [selectedMajors, setSelectedMajors] = useState<Major[]>(
    abstractProgram?.majors ?? [],
  );
  const [selectedInstitution, setSelectedInstitution] = useState<
    SupervisoryInstitution[]
  >(abstractProgram?.supervisory ?? []);

  const [selectedCourses, setSelectedCourses] = useState<
    AbstractCourse[] | null
  >(null);

  const [addNewCourses, setAddNewCourses] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (abstractProgram) {
      await abstractProgramAddCourses(
        abstractProgram.id,
        selectedCourses,
        closeDialog,
      );
    } else {
      await createNewAbstractCourseOperation(
        programName,
        programYears,
        selectedInstitution,
        selectedMajors,
        selectedCourses,
        setLoading,
        closeDialog,
      );
    }
  };

  const handleSelectedCourses = (abstractCourses: AbstractCourse[]) => {
    setSelectedCourses(abstractCourses);
    setAddNewCourses(false);
  };

  return (
    <div style={{ width: '100%', height: '95vh' }}>
      <div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            width: '752px',
            paddingTop: '16px',
            gap: '16px', // Space between items
            justifyContent: 'flex-start',
            marginBottom: '32px',
          }}
        >
          <EditText
            value={programName}
            title={'שם התוכנית'}
            onChange={setProgramName}
            disabled={!!abstractProgram}
          />
          <EditNumber
            value={programYears}
            disabled={!!abstractProgram}
            title={'מספר שנים'}
            onChange={setProgramYears}
          />

          <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                fontSize: '14px',
                color: '#4b5563',
                fontFamily: 'Heebo, sans-serif',
                marginBottom: '8px',
              }}
            >
              מגמות
            </div>
            <MultiSelect
              value={selectedMajors}
              onChange={(e) => setSelectedMajors(e.value)}
              options={globalSettingsStores.majors}
              optionLabel="majorName"
              placeholder="בחירת מגמה"
              maxSelectedLabels={3}
              disabled={!!abstractProgram}
              selectedItemsLabel={`${selectedMajors.length}  פריטים נבחקו`}
              style={{
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                minWidth: '250px',
              }}
            />
          </div>

          <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                fontSize: '14px',
                color: '#4b5563',
                fontFamily: 'Heebo, sans-serif',
                marginBottom: '8px',
              }}
            >
              גופים מפקחים
            </div>
            <MultiSelect
              value={selectedInstitution}
              onChange={(e) => setSelectedInstitution(e.value)}
              options={globalSettingsStores.supervisoryInstitution}
              optionLabel="institutionName"
              placeholder="גופים מפקחים"
              disabled={!!abstractProgram}
              selectedItemsLabel={`${selectedMajors.length}  פריטים נבחקו`}
              style={{
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                minWidth: '250px',
              }}
            />
          </div>
        </div>
      </div>

      <div style={{ fontSize: '12px' }}>
        * שים לב, ניתן להוסיף לתוכנית רק קורסים הנמצאים תחת אותה המגמה
      </div>

      <div style={{ marginTop: '8px' }} />

      <Button
        onClick={() => setAddNewCourses(true)}
        label={'להוספה'}
        style={{ height: '30px' }}
      />

      <AbstractProgramExistingCourses
        abstractProgramId={abstractProgram?.id}
        abstractCourses={abstractProgram?.courses ?? []}
      />

      <Dialog
        header="הוספת קורסים טיפוסיים"
        visible={addNewCourses}
        style={{ width: '80wh' }}
        onHide={() => {
          setAddNewCourses(false);
        }}
      >
        <div>
          <AbstractProgramFindCourses
            majors={selectedMajors}
            onHide={() => setAddNewCourses(false)}
            onSelectedCourses={(abstractCourses: AbstractCourse[]) =>
              handleSelectedCourses(abstractCourses)
            }
          />
        </div>
      </Dialog>

      <div
        style={{
          fontFamily: 'Heebo, sans-serif',
          marginTop: '16px',
          marginBottom: '8px',
          fontSize: '16px',
          visibility:
            !selectedCourses || selectedCourses.length === 0
              ? 'hidden'
              : 'initial',
        }}
      >
        הקורסים שנבחרו:
      </div>

      <div
        style={{
          width: '600px',
          display: 'flex',
          gap: '8px',
          flexWrap: 'wrap',
        }}
      >
        {selectedCourses &&
          selectedCourses.map((selectedCourseItem, index) => (
            <Chip
              key={selectedCourseItem.id} // Adding a key for each Chip
              label={selectedCourseItem.courseName}
              removable={true}
              onRemove={() => {
                // Filter out the selected item and update the state
                setSelectedCourses(
                  selectedCourses.filter(
                    (_, courseItemIndex) => courseItemIndex !== index,
                  ),
                );
              }}
            />
          ))}
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
          marginTop: '20px',
          paddingBottom: '10px',
          width: '100%',
        }}
      >
        <CancelButton
          onClick={() => {
            closeDialog();
          }}
        />

        <div style={{ width: '10px' }} />
        <ApproveButtons
          isLoading={loading}
          onClick={async () => {
            await handleSubmit();
          }}
        />
      </div>
    </div>
  );
};
